import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { ActivityLogs } from 'components/Vat/Report/activity-logs';
import { MessageStates } from 'containers/MessageBox';
import type { StoreState } from 'store/types';
import type { VatRunData } from 'store/vat/models';
import { fetchExcelActivityLogsRequest, addExcelActivityNoteRequest } from 'store/organisation/actions';
import { turnMessageOn } from 'store/app/actions';
/** Drawer content for organisation Excel activity logs: fetches logs and uses addExcelActivityNote. */
export const ExcelActivityLogsDrawerContent: React.FC<{
  organisationId: string;
  connectionId: string;
  mappingId: string;
  dataLogId: string;
}> = ({ organisationId, connectionId, mappingId, dataLogId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const organisation = useSelector((state: StoreState) =>
    state.organisation.organisations?.find((org) => org.uuid === organisationId)
  );
  const activityLogs = organisation?.activityLogs ?? [];

  React.useEffect(() => {
    dispatch(fetchExcelActivityLogsRequest(organisationId));
  }, [dispatch, organisationId]);

  const updateNoteExcel = React.useCallback(
    (noteText: string) => {
      if (!noteText || !noteText.trim()) {
        dispatch(
          turnMessageOn({
            title: t('main.reconciliation-empty-note-title'),
            description: t('main.reconciliation-empty-note-desc'),
            type: MessageStates.WARNING,
          })
        );
        return;
      }
      dispatch(addExcelActivityNoteRequest(organisationId, noteText));
    },
    [dispatch, organisationId, t]
  );

  const data: VatRunData = {
    dataLogId,
    tokenId: connectionId,
    mappingId,
    status: undefined,
  } as VatRunData;

  return (
    <ActivityLogs
      data={data}
      activityLogs={activityLogs}
      updateNote={(note, _dataLogId) => updateNoteExcel(note)}
      connectionId={connectionId}
      mappingId={mappingId}
      showAddNote
    />
  );
};
